<div class="container-fluid" style="padding: 20px 0 0 0; margin-bottom: 116px">

  <div class="input-group mb-3">
    <label for="orderNameField" class="col-md-4 col-form-label">Name des Auftrages</label>
    <div class="col-md-8">
      <input class="form-control" type="text" id="orderNameField" [ngModel]="params.jobName"
             (input)=onJobNameChange($event) placement="end" ngbTooltip="Erlaubt sind Buchstaben, Zahlen und die Sonderzeichen -_.">
    </div>
  </div>

  <div class="input-group mb-3">
    <label for="dateGroup" class="col-md-4 col-form-label">Zeitraum Sentinel-2</label>
    <div class="col-md-8">
      <div class="input-group mb-3" id="dateGroup">
        <input readonly class="form-control" id="startDate" placeholder="Beginn" name="dpBegin" ngbDatepicker
               [ngModel]="params.startDate">
      </div>
      <div class="input-group mb-3">
        <input readonly class="form-control" id="endDate" placeholder="Ende"
               name="dpEnd" [minDate]="minEndDate" [maxDate]="maxDatePicker" ngbDatepicker
               #endDate="ngbDatepicker" (dateSelect)="selectEndDate($event)" [ngModel]="params.endDate"
               (ngModelChange)="onToDateChange($event)">
        <div class="input-group-append">
          <button class="btn btn-outline-secondary calendar" (click)="endDate.toggle()" type="button">
            <img src="assets/icons/calendar.svg" alt="Symbol-Kalender" width="16" height="16" style="margin-bottom: 4px">
          </button>
        </div>
      </div>
      <div class="alert alert-primary" role="alert" *ngIf="params.validationDate === 0 && params.checkboxTimespan">
        {{labels.textChooseTimespan}}
      </div>
      <div class="alert alert-success" role="alert" *ngIf="params.validationDate === 1 && params.checkboxTimespan">
        {{labels.textValidTimespan}}
      </div>
      <div class="alert alert-danger" role="alert" *ngIf="params.validationDate === 2 && params.checkboxTimespan">
        {{labels.textInvalidTimespanRange}}
      </div>
      <div class="alert alert-danger" role="alert" *ngIf="params.validationDate === 3 && params.checkboxTimespan">
        {{labels.textInvalidTimespanWinterMonth}}
      </div>
    </div>
  </div>

  <div class="input-group mb-3 align-items-center">
    <label class="col-md-4 col-form-label">Automatisches Training</label>
    <div class="col-md-8">
      <div class="form-check form-switch">
        <input class="form-check-input" type="checkbox" role="switch" id="switchAutomaticTraining"
               [(ngModel)]="params.checkboxAutomaticTraining"
               (change)="params.setCheckboxAutomaticTraining(params.checkboxAutomaticTraining)" checked disabled>
        <label class="form-check-label" for="switchAutomaticTraining">Momentan ist nur das automatische Training
          verfügbar</label>
      </div>
    </div>
  </div>

  <div class="input-group mb-3 align-items-center">
    <label class="col-md-4 col-form-label">Qualitätsparameter LB</label>
    <div class="col-md-8">
      <div class="form-check form-switch">
        <input class="form-check-input" type="checkbox" role="switch" id="switchLB"
               [(ngModel)]="params.checkboxLB" (change)="params.setCheckboxLB(params.checkboxLB)"
               [checked]="!selectedProduct || selectedProduct === 'LB'">
        <label class="form-check-label" for="switchLB"></label>
      </div>
    </div>
  </div>

  <hr>

  <div class="input-group mb-3">
    <div class="col-md-8">
      <b>Optionale Angaben</b>
    </div>
  </div>

  <div class="input-group mb-3">
    <label for="dopUploadID" class="col-md-6 col-form-label">DOP Upload-ID</label>
    <div class="col-md-6">
      <input class="form-control" type="text" id="dopUploadID" (change)="params.setDopUploadID(params.dopUploadID)"
             [(ngModel)]="params.dopUploadID">
    </div>
  </div>

  <div class="input-group mb-3">
    <label for="alkisUploadID" class="col-md-6 col-form-label">ALKIS Upload-ID</label>
    <div class="col-md-6">
      <input class="form-control" type="text" id="alkisUploadID"
             (change)="params.setAlkisUploadID(params.alkisUploadID)" [(ngModel)]="params.alkisUploadID">
    </div>
  </div>

  <div class="input-group mb-3">
    <label for="ndomUploadID" class="col-md-6 col-form-label">nDOM Upload-ID</label>
    <div class="col-md-6">
      <input class="form-control" type="text" id="ndomUploadID" (change)="params.setNdomUploadID(params.ndomUploadID)"
             [(ngModel)]="params.ndomUploadID">
    </div>
  </div>

  <!-- <div class="input-group mb-3">
    <label for="trainingDataUploadID" class="col-md-6 col-form-label">Manuelle Trainingsdaten Upload-ID
     </label>
    <div class="col-md-6">
      <input class="form-control" type="text" id="trainingDataUploadID"
             (change)="params.setTrainingDataUploadID(params.trainingDataUploadID)"
             [(ngModel)]="params.trainingDataUploadID">
    </div>
  </div> -->

  <div class="input-group mb-3">
    <label for="validationDataUploadID" class="col-md-6 col-form-label">Validierungsdaten Upload-ID</label>
    <div class="col-md-6">
      <input class="form-control" type="text" id="validationDataUploadID"
             (change)="params.setValidationDataUploadID(params.validationDataUploadID)"
             [(ngModel)]="params.validationDataUploadID">
    </div>
  </div>

  <div class="input-group mb-3">
    <label for="cdMaskUploadID" class="col-md-6 col-form-label">Maske Veränderungshinweissuche Upload-ID
     </label>
    <div class="col-md-6">
      <input class="form-control" type="text" id="cdMaskUploadID"
             (change)="params.setCdMaskUploadID(params.cdMaskUploadID)" [(ngModel)]="params.cdMaskUploadID">
    </div>
  </div>

  <div class="input-group mb-3">
    <label for="cdFilterUploadID" class="col-md-6 col-form-label">Filter Veränderungshinweissuche Upload-ID
     </label>
    <div class="col-md-6">
      <input class="form-control" type="text" id="cdFilterUploadID"
             (change)="params.setCdFilterUploadID(params.cdFilterUploadID)" [(ngModel)]="params.cdFilterUploadID">
    </div>
  </div>

  <div>
    <ngb-alert [dismissible]="false" *ngIf="validateProdukt.message.length > 0" type="{{validateProdukt.type}}">
      <ul *ngFor="let item of validateProdukt.message">
        <li>{{ item }}</li>
      </ul>
    </ngb-alert>
  </div>
  <div class="d-flex flex-row align-items-center justify-content-end" style="width: 100%">
    <button type="button" class="btn btn-outline-danger" (click)="openModal(newProduct)">Neuer Auftrag</button>&nbsp;&nbsp;
    <button type="button" class="btn btn-outline-primary" (click)="addProductToCart()">Auftrag in den Warenkorb</button>
  </div>
</div>

<app-loader class="appLoader" *ngIf="showLoader"></app-loader>

<ng-template #newProduct let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Neuer Auftrag</h4>
  </div>
  <div class="modal-body">
    <p>Möchten Sie wirklich einen Auftrag anlegen und alle bisherigen Eingaben zurücksetzen?</p>
  </div>
  <div class="modal-footer">
    <button class="btn btn-outline-primary" (click)="modal.close('Close click')">
      Nein
    </button>
    <button class="btn btn-outline-danger" (click)="clearProduct()">
      Ja
    </button>
  </div>
</ng-template>

<ng-template #help let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Hinweis zum Zeitraum</h4>
    <button class="btn btn-outline-secondary" type="button" title="Schließen" aria-label="Close" (click)="modal.dismiss('cross click')">
      <img src="assets/icons/close.svg" alt="Schließen" width="16" height="16" style="margin-bottom: 4px">
    </button>
  </div>
  <div class="modal-body">
    <p>
      Bitte geben Sie an, aus welchem Zeitraum Sentinel-2-Bilder verwendet werden sollen.
      Der Zeitraum beträgt 1 Jahr und wird automatisch zurückgerechnet.
    </p>
    <input type="checkbox" class="form-check-input" id="checkbox-hide-timeframe-help"
           (change)="toggleTimeframeHelp()" [(ngModel)]="hideHelp">
    <label class="form-check-label" for="checkbox-hide-timeframe-help">
      Diesen Hinweis nicht mehr anzeigen
    </label>
  </div>
</ng-template>
